<template>
    <div class="profiler">
        <div class="profile-left">
            <div class="profile-head">
                <img :src="headPic">
                <div class="uploads">
                    <input type="file" v-on:change="selectFile">
                    <a href="javascript:;" class="set-head text-primary">{{$t('user_center_set_head')}}</a>
                </div>
            </div>
        </div>
        <div class="profile-right">
            <div class="profile-group profile-inline">
                <label>{{$t('user_center_email')}}:</label>
                <div class="profile-input">
                    {{userinfo.email}}
                </div>
            </div>
            <div class="profile-group profile-inline">
                <label>iPoint:</label>
                <div class="profile-input">
                    <span class="ipoint-num">{{userinfo.ipoint}}</span>
                    <button type="button" class="btn-modify-sm" @click="goToTopUp">{{$t('top_up')}}</button>
                </div>
            </div>
            <div class="profile-group profile-inline">
                <div class="profile-input input-space">
                    <span class="profile-name">{{userinfo.nickname}}</span>
                    <button class="btn-modify btn-big btn-text" @click="isShowModName = true">
                        <img src="../../assets/profile/icon_edit_blue.png" width="26">{{$t('user_center_btn_modify')}}
                    </button>
                </div>
            </div>
            <div class="profile-group">
                <label>{{$t('user_center_manage_address')}}:</label>
                <div class="profile-input">
                    <addr v-if="address"
                          v-for="(item,index) in address"
                          v-bind:addr="item"
                          :key="index"
                          v-bind:checked-num="index"
                          v-bind:id="item.address_id"
                          v-on:checked="setChecked(index)"
                          v-on:deladdr="delAddress(index)"
                          v-on:modifyaddr="modifyAddr"
                    ></addr>
                    <p style="margin-top: 15px;">
                        <button class="btn-modify btn-big" @click="addAddress =true">
                            {{$t('user_center_add_address')}}
                        </button>
                    </p>
                </div>
            </div>

            <div class="profile-group">
                <label>{{$t('user_center_security')}}</label>
                <div class="profile-input">
                    <h2 class="security-title">{{$t('user_center_account_password')}}</h2>
                    <div class="profile-security-list">
                        <p class="security-content">{{$t('user_center_account_password_tip')}}</p>
                        <p style="margin-top: 5px">
                            <button class="btn-modify btn-big btn-text" @click="change_password_modal = true">
                                <img src="../../assets/profile/icon_edit_blue.png" width="26">{{$t('user_center_btn_modify')}}
                            </button>
                        </p>
                    </div>
                    <h2 class="security-title">{{$t('user_center_Safety phone')}}</h2>
                    <div class="profile-security-list">
                        <p class="security-content" v-if="isNumber">
                           {{$t('user_center_bind_your_number')}}
                        </p>
                        <p class="security-content" v-else>
                            {{add_phone}}
                        </p>
                        <p style="margin-top: 5px">
                            <button class="btn-modify btn-big btn-text" @click="bindthephone = true" v-if="isNumber">
                                <img src="../../assets/profile/icon_edit_blue.png" width="26">{{$t('add_number')}}
                            </button>
                        </p>
                    </div>
                </div>
            </div>
            <div class="profile-group">
                <label>{{$t('my_card')}}</label>
                <div class="profile-input">
                    <p class="security-content" style="width:100%;font-size: 14px;color: #5E6D82;" v-if="null_card">{{$t('user_center_security_bind_card')}}<router-link style="color:#0084ff;" :to="{name:'app'}">{{$t('download_btn')}}</router-link>{{$t('user_center_security_bind_card1')}}</p>
                    <ul class="card-list">
                        <Row>
                            <i-col :lg="8" :md="8" :sm="12" :xs="12">
                                <img class="mogos_card" v-show="mogos_card" src="../../assets/profile/mogos_200@2x.png"
                                     alt="" width="100%">
                            </i-col>
                            <i-col :span="8" :md="8" :sm="12" :xs="12">
                                <img class="ichat_card" v-show="ichat_card" src="../../assets/profile/ichat_200@2x.png"
                                     alt="" width="100%">
                            </i-col>
                            <i-col :span="8" :md="8" :sm="12" :xs="12">
                                <img class="iglobal_card" v-show="iglobal_card" src="../../assets/store/iglobal.png"
                                     alt="" width="110%" style="margin-top: -10px;">
                            </i-col>
                        </Row>
                    </ul>
                </div>
            </div>
        </div>

        <!--更改密码窗口-->
        <modal v-model="change_password_modal" size="small" class="modal-group-scc">
            <div slot="header"></div>
            <div class="page-content">
                <div class="change_password-title">
                    <h2>{{$t('user_center_account_password_change_psw')}}</h2>
                </div>
                <div class="change_password-main">
                    <p class="change_password_p">{{$t('user_center_account_password_original_psw')}}</p>
                    <input v-validate="'required|min:6'" name="change_passeword_old_psw" v-model="oldPassword"
                           class="change_password_input" type="text"
                           :class="{'is-error': errors.has('change_passeword_old_psw')}"
                           :placeholder="$t('user_center_account_password_original_psw')">
                </div>
                <div class="change_password-main">
                    <p class="change_password_p">{{$t('user_center_account_password_new_psw')}}</p>
                    <input v-validate="'required|min:6'" name="change_password_new_password1" v-model="newPassword1"
                           class="change_password_input" type="text"
                           :class="{'is-error': errors.has('change_password_new_password1')}"
                           :placeholder="$t('user_center_account_password_new_psw')">
                </div>
                <div class="change_password-main">
                    <input v-validate="'required|min:6'" name="change_password_new_password2" v-model="newPassword2"
                           class="change_password_input" type="text"
                           :class="{'is-error': errors.has('change_password_new_password2')}"
                           :placeholder="$t('user_center_account_password_re_psw')">
                </div>
                <!--<p class="change_password_tip">Tips:Here is the content</p>-->
                <div class="change_password-nex-btn">
                    <button @click="change_password">OK</button>
                </div>
            </div>
            <div slot="footer"></div>
        </modal>

        <!--添加地址窗口-->
        <modal v-model="addAddress" @on-cancel="cancelAddress" class="addAddress_modal">
            <div slot="header"></div>
            <div class="add-address-title">
                <p>{{$t('user_center_add_address_tittle')}}</p>
            </div>
            <input type="hidden" v-if="addAddressGroup.address_id !== null" v-model="addAddressGroup.address_id">
            <div class="addr_modal">
                <p class="addr_modal_tips">{{$t('user_center_Coupons_Use_tips')}}: <span>*</span>{{$t('add_address_must_item')}}</p>
                <div class="addr_group">
                    <div class="addr_laber">
                        {{$t('add_address_area')}}<span>*</span>
                    </div>
                    <div class="addr_item1">
                        <select name="addAddressGroup_country" v-model="addAddressGroup.country">
                            <option :value="item.id" v-for="(item,index) in countrys"
                            :key="index">   {{item.country_name}}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="addr_group">
                    <div class="addr_laber">
                        {{$t('add_address_address')}}<span>*</span>
                    </div>
                    <div class="addr_item2">
                        <textarea cols="30" rows="6" :placeholder="$t('add_address_address_full')" v-validate="'required'" name="addAddressGroup_address"
                        :class="{'is-error': errors.has('addAddressGroup_address')}"
                        v-model="addAddressGroup.address"></textarea>
                    </div>
                </div>
                <div class="addr_group">
                    <div class="addr_laber">
                        {{$t('add_address_zip_code')}}
                    </div>
                    <div class="addr_item1">
                        <input type="text" v-validate="'required|numeric'" name="addAddressGroup_zipcode" :placeholder="$t('add_address_zip_code_full')"
                        :class="{'is-error': errors.has('addAddressGroup_zipcode')}"
                        v-model="addAddressGroup.zipcode">
                    </div>
                </div>
                <div class="addr_group">
                    <div class="addr_laber">
                        {{$t('about_ifree_join_sub_name')}}<span>*</span>
                    </div>
                    <div class="addr_item1">
                        <input type="text" v-validate="'required|min:1'" :placeholder="$t('add_address_first_name_full')" name="addAddressGroup_last_name"
                        :class="{'is-error': errors.has('addAddressGroup_last_name')}"
                        v-model="addAddressGroup.name"
                        >
                    </div>
                </div>
                <div class="addr_group">
                    <div class="addr_laber">
                        {{$t('about_ifree_join_sub_number')}}<span>*</span>
                    </div>
                    <div class="addr_item1">
                        <select v-model="addAddressGroup.area_code" style="margin-bottom: 10px;">
                            <option v-for="(item,index) in cityiso" :value="item.area_code" :key="index">
                                {{item.area_code}} {{item.name}}
                            </option>
                        </select>
                        <input v-validate="'required|min:11'" name="bind_phone" v-model="addAddressGroup.mobile"
                               :class="{'is-error': errors.has('bind_phone')}" type="text" class="form-input"
                               :placeholder="this.$t('add_number_number')">
                    </div>
                </div>
                <div class="addr_group">
                    <div class="addr_laber"></div>
                    <div class="addr_item1">
                        <Checkbox style="font-size: 14px;color: #5E6D82;" @on-change="check_default" class="checkALL" v-model="default_single">
                            {{$t('add_address_defult_address')}}
                        </Checkbox>
                    </div>
                </div>
                <div class="addr_group">
                    <div class="addr_laber"></div>
                    <div class="addr_item1">
                        <button class="btn-pt btn-blue" @click="saveAddress">
                            {{$t('determine_btn')}}
                        </button>
                    </div>
                </div>
            </div>

            <div slot="footer"></div>

        </modal>

        <!--修改昵称窗口-->
        <modal v-model="isShowModName" :title="$t('user_change_nickname')" class="change_nickname">
            <input type="hidden" v-model="userinfo.user_id">
            <div class="form-group">
                <div class="form-input">
                    <input type="text"
                           v-validate="'required'"
                           name="modifyNickName"
                           :class="{'is-error': errors.has('modifyNickName')}"
                           v-model="userinfo.nickname">
                </div>
            </div>
            <div class="profile-group" width="100%">
                <button class="btn-big btn-modify-sm" @click="modifyNickName" style="margin: 0 auto">
                    {{ $t('user_center_btn_modify')}}
                </button>
            </div>
            <div slot="footer"></div>

        </modal>

        <!--绑定手机号窗口-->
        <modal v-model="bindthephone" size="small" class="modal-group-scc">
            <div slot="header"></div>
            <div class="page-content">
                <div class="change_password-title">
                    <h2>{{$t('add_number')}}</h2>
                </div>
                <div class="change_password-main">
                    <p class="change_password_p">{{$t('add_number_number')}}</p>
                    <div class="form-group form-inline" id="bind_the_phone">
                        <select v-model="bind_iso">
                            <option v-for="(item,index) in cityiso" :value="item.area_code" :key="index">
                                {{item.area_code}} {{item.name}}
                            </option>
                        </select>
                        <input v-validate="'required|min:11'" name="bind_phone" v-model="add_mobile"
                               :class="{'is-error': errors.has('bind_phone')}" type="text" class="form-input"
                               :placeholder="this.$t('add_number_number')">
                    </div>
                </div>
                <div class="change_password-main">
                    <div class="profile-security-list-1">
                        <input v-validate="'required|min:4'" name="verification_code" v-model="code"
                               class="change_password_input" type="text"
                               :class="{'is-error': errors.has('verification_code')}" :placeholder="this.$t('add_number_verification_code')">
                        <p>
                            <button class="btn-modify btn-big" v-show="show" @click="getCode">
                                {{$t('send_code')}}
                            </button>
                        </p>
                        <span v-show="!show" class="count">{{count}} s</span>
                    </div>
                </div>
                <!--<p class="change_password_tip">Tips:Here is the content</p>-->
                <div class="change_password-nex-btn">
                    <button @click="add_password" @keyup.enter="add_password">OK</button>
                </div>
            </div>
            <div slot="footer"></div>
        </modal>
        <BackTop>
            <div class="top">
                <img src="../../assets/backtop/top.png">
                <p style="">TOP</p>
            </div>
        </BackTop>
        <a href="http://ifree.ly/support" target="_blank">
            <BackTop :height="100" :bottom="110">
                <div class="top">
                    <img src="../../assets/backtop/service.png">
                    <p>Service</p>
                </div>
            </BackTop>
        </a>
    </div>
</template>

<script>
    import addressgroup from './AddressGroup.vue'
    import addr from './Address.vue'
    import Signature from '../../lib/Signature'
    import modal from '../Common/Modal.vue'

    export default {
        data () {
            return {
                mogos_card: false,
                iglobal_card: false,
                ichat_card: false,
                default_single:false,
                null_card:false,
                isNumber:  true,
                add_phone: '',
                vertical: 'apple',
                address: [],
                show: true,
                count: '',
                timer: null,
                add_mobile: '',
                bind_iso: '86',
                addAddressGroup: {
                    address_id: null,
                    name: '',
                    country: '35',
                    address: '',
                    zipcode: '',
                    mobile: '',
                    area_code:'86',
                },
                default:0,
                flag: 0,
                change_password_modal: false,
                oldPassword: '',
                newPassword1: '',
                newPassword2: '',
                mobileNumber: '',
                validation: '',
                bindthephone: false,
                code: '',
                current: 0,
                userinfo: {
                    nickname: ''
                },
                addAddress: false,
                countrys: '',
                isShowModName: false,
                cityiso: [],
                headPic: this.Local.get('users').user_info.head_pic || ''
            }
        },
        created () {
            let module = 'index.php/index/user/getcountry'
            let data = {}
            data.sub_time = Signature.timestamp()
            data.lang = this.$i18n.locale
            data.sign = Signature.create(module, data.sub_time)
            data.user_id = this.Local.getUserId()
            data.token = this.Local.getUserToken()
            this.$http.get(process.env.BASEURL + module, {params: data})
                .then(function (response) {
                    if (parseInt(response.data.code) === 2000) {
                        console.log(response.data)
                        this.countrys =response.data.data.country_list
                    }
                }.bind(this))
        },
        methods: {
            check_default(){
                if(this.default_single == true){
                    this.default = 1
                }
            },
            selectFile (e) {
                // 上传头像
                const module = 'index.php/index/user/edituser'
                let file = e.target.files[0]
                let param = new FormData()
                let config = {
                    headers: {'Content-Type': 'multipart/form-data'}
                }
                let subTime = Signature.timestamp()
                let sign = Signature.create(module, subTime)
                param.append('image', file, file.name)
                param.append('user_id', this.Local.getUserId())
                param.append('token', this.Local.getUserToken())
                param.append('sub_time', subTime)
                param.append('sign', sign)
                this.$http.post(process.env.BASEURL + module, param, config)
                    .then(function (resp) {
                        if (parseFloat(resp.data.code) === 2000) {
                            this.Local.set('users', resp.data.data)
                            this.headPic = resp.data.data.user_info.head_pic
                        }
                    }.bind(this))
            },
            modifyNickName () {
                const module = 'index.php/index/user/edituser'
                let data = {}
                data.token = this.Local.get('users').token
                data.user_id = this.Local.get('users').user_id
                data.nickname = this.userinfo.nickname
                data.sub_time = Signature.timestamp()
                data.sign = Signature.create(module, data.sub_time)
                this.$http.post(process.env.BASEURL + module, data)
                    .then(function (resp) {
                        if (parseInt(resp.data.code) === 2001) {
                            alert(resp.data.msg)
                            return false
                        }

                        if (parseInt(resp.data.code) === 2000) {
                            //                            this.$toast.success('修改成功')
                            this.$Message.success(this.$t('modify_suceess'))
                            this.isShowModName = false
                            let users = this.Local.get('users')
                            users.user_info.nickname = this.userinfo.nickname
                            this.Local.set('users', users)
                        } else {
                            alert(resp.data.msg)
                        }
                    }.bind(this))
            },
            goToTopUp () {
                this.$router.push({name: 'iPoint'})
            },
            modifyAddr (data) {
                for (let i in this.address) {
                    if (this.address[i].address_id === data.address_id) {
                        this.address[i] = data
                    }
                }
            },
            delAddress (index) {
                let module = 'index.php/index/user/deladdress'
                if (!confirm(this.$t('delete_the_address'))) return
                let data = {}
                data.sub_time = Signature.timestamp()
                data.sign = Signature.create(module, data.sub_time)
                data.user_id = this.Local.get('users')['user_id']
                data.address_id = this.address[index].address_id
                this.$http.post(process.env.BASEURL + module, data)
                    .then(function (resp) {
                        this.address.splice(index, 1)
                    }.bind(this))
            },
            saveNewPassword () {

            },
            cancelPassword () {

            },
            cancelAddress () {
                this.addAddress = false
            },
            saveNewNumber (e) {
                if (this.current < 2) {
                    this.current += 1
                }
                if (this.current === 1) {
                    alert(1)
                } else if (this.current === 2) {
                    alert(2)
                }
            },
            cancelNumber (e) {
                if (this.current === 1) {
                    e.target.innerText = 'Cencel'
                } else {
                    e.target.innerText = 'Prev'
                }
                if (this.current > 0) {
                    this.current -= 1
                } else {
                    this.changeNumber = false
                }
            },
            saveAddress () {
                let module = 'index.php/address'
                let data = {}
                for (let item in this.addAddressGroup) {
                    data[item] = this.addAddressGroup[item]
                }
                data.default = this.default
                data.lang = this.$i18n.locale
                data.sub_time = Signature.timestamp()
                data.sign = Signature.create(module, data.sub_time)
                data.user_id = this.Local.get('users')['user_id']
                this.$http.post(process.env.BASEURL + module, data).then(function (resp) {
                    if (parseInt(resp.data.code) === 2000) {
                        this.address.push(resp.data.data.address_info)
                        this.addAddress = false
                    }
                    if (parseInt(resp.data.code) === 2001) {
                        this.$Message.error(resp.data.msg)
                    }
                }.bind(this))
            },
            setChecked (index) {
                for (let item of this.address) {
                    item.is_default = 0
                }
                let module = 'index.php/index/user/defaultaddress'
                let data = {}
                data.sub_time = Signature.timestamp()
                data.sign = Signature.create(module, data.sub_time)
                data.user_id = this.Local.get('users')['user_id']
                data.address_id = this.address[index].address_id
                this.$http.post(process.env.BASEURL + module, data)
                    .then(function (resp) {
                        if (parseInt(resp.data.code) === 2000) {
                            this.address[index].is_default = 1
                        }
                    }.bind(this))
            },
            change_password () {
                if (this.newPassword1 === this.newPassword2) {
                    const module = 'index.php/index/user/repwd'
                    let data = {}
                    data.re_password = this.oldPassword
                    data.new_password = this.newPassword1
                    data.new_password = this.newPassword2
                    data.sub_time = Signature.timestamp()
                    data.token = this.Local.getUserToken()
                    data.user_id = this.Local.getUserId()
                    data.sign = Signature.create(module, data.sub_time)
                    this.$http.post(process.env.BASEURL + module, data).then(function (resp) {
                        if (parseInt(resp.data.code) === 2001) {
                            this.$Message.error(resp.data.msg)
                            return false
                        }
                        if (parseInt(resp.data.code) === 2000) {
                            this.$Message.success(this.$t('modify_suceess'))
                            this.Local.unset('users')
                            this.$router.push('/')
                        } else {
                            this.$Message.error(resp.data.msg)
                        }
                    }.bind(this))
                } else {
                    this.$Message.error(this.$t('same_password'))
                }
            },
            getCode () {
                //  发送邮件接口
                let module = 'index.php/index/user/sendcode'
                let data = {}
                data.mobile = this.add_mobile
                data.area_code = this.bind_iso
                data.sub_time = Signature.timestamp()
                data.sign = Signature.create(module, data.sub_time)
                this.$http.post(process.env.BASEURL + module, data).then(function (resp) {
                    if (parseInt(resp.data.code) === 2000) {
                        this.$Message.success(this.$t('send_code_suceess'))
                        // 发送邮件倒计时
                        this.countdown()
                    } else {
                        this.$Message.error(resp.data.msg)
                    }
                }.bind(this))
            },
            countdown () {
                // 发送邮件倒计时
                const TIME_COUNT = 60
                if (!this.timer) {
                    this.count = TIME_COUNT
                    this.show = false
                    this.timer = setInterval(() => {
                        if (this.count > 0 && this.count <= TIME_COUNT) {
                            this.count--
                        } else {
                            this.show = true
                            clearInterval(this.timer)
                            this.timer = null
                        }
                    }, 1000)
                }
            },
            add_password () {
                //绑定手机
                let module = 'index.php/index/user/bindmobile'
                let data = {}
                data.area_code = this.bind_iso
                data.mobile = this.add_mobile
                data.code = this.code
                data.token = this.Local.get('users').token
                data.user_id = this.Local.get('users').user_id
                data.sub_time = Signature.timestamp()
                data.sign = Signature.create(module, data.sub_time)
                this.$http.post(process.env.BASEURL + module, data).then(function (resp) {
                    if (parseInt(resp.data.code) === 2000) {
                        this.add_phone = resp.data.data.mobile
                        this.$Message.success(this.$t('bind_phone_suceess'))
                        this.bindthephone = false
                    } else {
                        this.$Message.error(resp.data.msg)
                    }
                }.bind(this))
            },
            iso () {
                let data = {}
                let module = 'index.php/index/other/isocountry'
                data.sub_time = Signature.timestamp()
                data.lang = this.$i18n.locale
                data.sign = Signature.create(module, data.sub_time)
                this.$http.post(process.env.BASEURL + module, data)
                    .then(function (resp) {
                        if (parseInt(resp.data.code) === 2000) {
                            this.cityiso = resp.data.data.country_list
                        }
                    }.bind(this))
            }
        },
        components: {
            addressgroup,
            addr,
            modal
        },
        mounted () {
            this.userinfo = this.Local.get('users').user_info
            let data = {}
            const module = 'index.php/index/user/addressinfo'
            data.sub_time = Signature.timestamp()
            data.token = this.Local.getUserToken()
            data.sign = Signature.create(module, data.sub_time)
            data.user_id = this.Local.get('users').user_id
            this.$http.post(process.env.BASEURL + module, data)
                .then(function (resp) {
                    if (resp.data.data) {
                        this.address = resp.data.data.address_info
                    }
                }.bind(this))

            // 获取国家iso
            this.iso()

            //手机号
            this.add_phone = this.Local.get('users').user_info.mobile
            if(!this.add_phone){
               this.isNumber = true
            }else{
               this.isNumber = false
            }


            // my card
            var mogos_iccid = this.Local.get('users').user_info.mogos_iccid
            var ichat_iccid = this.Local.get('users').user_info.ichat_iccid
            var iglobal_iccid = this.Local.get('users').user_info.global_iccid
            if(!mogos_iccid && !ichat_iccid && !iglobal_iccid){
                this.null_card = true
            }
            if (mogos_iccid != null) {
                this.mogos_card = true
            }
            if (ichat_iccid != null) {
                this.ichat_card = true
            }
            if (iglobal_iccid != null) {
                this.iglobal_card = true
            }
        }
    }
</script>

<style lang="scss">
    @import "../../scss/personal/profile";
    @import "../../scss/components/form";
</style>



// WEBPACK FOOTER //
// Profile.vue?a763cee8